export default () => {
  return 'https://server.namfoong.com.my'
}